import Vue from 'vue'

Vue.filter('percent', value => {
    return `${value || 0}%`
})
